<template>
	<v-container>
		<common-table
			:options.sync="tableOptions"
			:headers="headers"
			:items="packagings"
			:items-length="packagings.length"
			:items-per-page="tableOptions.itemsPerPage"
			:items-per-page-options="tableFooterProps.itemsPerPageOptions"
			hide-default-footer
			style="cursor: pointer"
			disable-sort
			@row-click="showDialog"
			@delete-item="deletePackaging"
		/>
		<v-btn class="mt-6" color="accent" outlined large elevation="0" @click="showDialog(null)">
			<v-icon class="icon-plus mr-2" start size="medium"></v-icon>
			{{ $t("add_new_packaging") }}
		</v-btn>
		<packaging-dialog
			:key="dialog.item ? dialog.item.id || dialog.item._id || 'new' : 'new'"
			v-model="dialog.visibility"
			:item="dialog.item"
			@saved="dialogSaved"
			@deleted="dialogDeleted"
		/>
	</v-container>
</template>

<script>
import uiMixin from "../../../store/interfaces/ui.mixin";
import remote from "../../../data/remote";
import PackagingDialog from "./dialogs/PackagingDialog.vue";
import CommonTable from "../../partials/CommonTable.vue";
import { mapGetters } from "vuex";

export default {
	mixins: [uiMixin],
	components: { PackagingDialog, CommonTable },
	data() {
		return {
			tableOptions: { itemsPerPage: 10 },
			tableFooterProps: { itemsPerPageOptions: [5, 10, 15, 20] },
			loading: true,
			packagings: [],
			headers: [
				{ text: this.$t("name"), value: "nameText" },
				{ text: this.$t("prefix"), value: "prefix" },
				{ text: this.$t("actions"), value: "actions" },
			],
			dialog: { visibility: false, item: null },
		};
	},
	computed: {
		...mapGetters(["company"]),
	},
	methods: {
		loadItems() {
			this.loading = true;
			remote.references.filter(
				{ type: "PACKAGING" },
				{
					onSuccess: (result) => {
						const list = Array.isArray(result) ? result : result.items || [];
						this.packagings = list.map((p) => {
							const label = p.label || p.name || {};
							const text = label[this.$i18n.locale] || label._default || "";
							const id = p._id || p.id;
							const prefix = p.code || p.key || "";
							return { ...p, id, nameText: text, name: label, prefix };
						});
						this.loading = false;
					},
					onFail: () => {
						this.loading = false;
					},
				}
			);
		},
		showDialog(row) {
			this.dialog.item = row ? { ...row } : null;
			this.$nextTick(() => {
				this.dialog.visibility = true;
			});
		},
		hideDialog() {
			this.dialog.item = null;
			this.dialog.visibility = false;
		},
		dialogSaved() {
			this.hideDialog();
			this.loadItems();
		},
		dialogDeleted() {
			this.hideDialog();
			this.loadItems();
		},
		deletePackaging(row) {
			this.showConfirmDialog({
				message: this.$t("delete_confirm_message"),
				onConfirm: () => {
					this.showProgressDialog();
					remote.references.delete(row.id, {
						onSuccess: () => {
							this.hideProgressDialog();
							this.showSnackBar({
								message: this.$t("$message.deleted", { item: this.$t("packaging") }),
							});
							this.loadItems();
						},
						onFail: () => {
							this.hideProgressDialog();
						},
					});
				},
			});
		},
	},
	created() {
		this.loadItems();
	},
};
</script>
